import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import * as XLSX from 'xlsx';
import jspdf from 'jspdf';
import html2canvas from 'html2canvas';
import { ConexionService } from 'src/app/servicios/conexion.service';
import { UtilidadesService } from 'src/app/servicios/utilidades.service';
import { PopoverController } from '@ionic/angular';
import { OpcionesExportarComponent } from 'src/app/componentes/opciones-exportar/opciones-exportar.component';


@Component({
  selector: 'app-comprobantes-fiscales',
  templateUrl: './comprobantes-fiscales.component.html',
  styleUrls: ['./comprobantes-fiscales.component.scss'],
})
export class ComprobantesFiscalesComponent implements OnInit {
  Documentos = []
  Fecha = { Fecha1: "", Fecha2: "" }
  Copia = ""
  @Input() UserID = ""
  @Output() recargar = new EventEmitter();
  @Output() correo = new EventEmitter();
  @ViewChild('pdfTable') pdfTable: ElementRef;
  @Output() desabilitar = new EventEmitter();
  disabled: boolean = true;
  pdf: string = ""

  filtro = ""
  filtrado = false;

  HijosSeleccionados = []

  Datos(v: Array<any>) {
    this.getConfiguraciones()
    if (v.length > 0) {
      setTimeout(() => {
        this.Documentos = v
        this.CrearPropiedadesAdiocionales()
      }, 100);
    }
  }

  HijosSelect = []
  RNC = ""

  @Input() HijosPreCargados = []
  @Input() PrecargarHijos = false;

  constructor(private conexion: ConexionService, private utilidades: UtilidadesService,
    private popoverController: PopoverController) { }

    ngOnChanges(): void {
      if(this.PrecargarHijos){
        let hs = []
  
        for (let i of this.HijosPreCargados) {
          hs.push({
            Nombre: i.Nombre1 + " " + i.Apellido1,
            Foto: "https://ofdpinternacional.com/wp-content/uploads/2018/09/5.jpg", Value: i.Id
          })
        }
  
        this.HijosSelect = hs
      }
    }

  ngOnInit() {
    if (!this.PrecargarHijos) {
      this.getTodosLosHijosDeFamilias()
    } 
    setTimeout(() => {
      this.HayDatos()
    }, 10000);
    setTimeout(() => {
      this.getComprobantesFiscalesFamiliasVinculadasAMi()
    }, 100);

  }

  async Exportar(e: Event) {
    const popover = await this.popoverController.create({
      component: OpcionesExportarComponent,
      event: e,
    });

    await popover.present();

    const { data } = await popover.onDidDismiss();

    this.utilidades.Depuracion(data, "console", "")
    if (data == "pdf") {
      this.pdfF()
    } else if (data == "excel") {
      this.exportexcel()
    }
  }

  getComprobantesFiscalesFamiliasVinculadasAMi() {
    this.utilidades.Loading("Cargando documentos")
    this.conexion.getComprobantesFiscalesFamiliasVinculadasAMi(this.UserID,
      this.Fecha.Fecha1, this.Fecha.Fecha2).subscribe((resp) => {
        this.desabilitar.emit(false)
        this.disabled = false;
        this.utilidades.CerrarLoading()
        this.utilidades.Depuracion(resp, "console", "")
        if (resp.Respuesta == "Exito") {
          this.Datos(resp.Datos)

        }
      }, (err) => {
        this.utilidades.CerrarLoading()
        this.utilidades.Alerta("En estos momentos este servicio no se encuentra disponible. Por favor, inténtelo más tarde.")
        this.desabilitar.emit(true)
        this.disabled = true;
        this.utilidades.ValidarUser(err)
      })
  }

  getConfiguraciones() {
    this.conexion.getConfiguraciones().subscribe((resp) => {
      this.utilidades.Depuracion(resp, "console", "")
      for (let i of resp.Datos) {
        if (i.Configurable == "RNC") {
          this.RNC = i.Dato
        }
      }
      
    })
  }

  getTodosLosHijosDeFamilias() {
    let familias = JSON.parse(atob(localStorage.getItem(btoa("Familias"))))
    let fams = []
    for (let i of familias) {
      console.log(i)
      fams.push(i.CodigoFamilia)
    }
    this.conexion.getTodosLosHijosDeFamilias(fams.toString()).subscribe((resp) => {
      let hs = []
      
      for(let i of resp.Datos){
        hs.push({
          Nombre: i.Nombre1 + " " + i.Apellido1,
          Foto: "https://ofdpinternacional.com/wp-content/uploads/2018/09/5.jpg", Value: i.Id
        })
      }

      this.HijosSelect = hs

    })
  }

  EstaHijo(idest, arr) {
    for (let i of arr) {
      if (String(idest) == String(i.Id)) {
        return true;
      }
    }
    return false;
  }

  Sumar(array, key): number {
    let total: number = 0
    for (let i of array) {
      if ((this.EnArreglo(i.IdEstudiante, this.HijosSeleccionados))) {
        total += Number(i[key])
      }
    }
    return total
  }

  Imprimir() {

    let vent = window.open('', '', 'height=800, width=800');
    vent.document.write(this.TextoMostrable())
    vent.document.close()
    setTimeout(() => {
      vent.print()
    }, 300);

  }

  Totales(key) {
    let total = 0
    for (let fams of this.Documentos) {
      total += Number(this.Sumar(fams.Datos, key))
    }

    return total
  }

  CrearPropiedadesAdiocionales() {

    for (let i in this.Documentos) {
      for (let j in this.Documentos[i].Datos) {
        if (this.Documentos[i].Datos[j].Estado == -1) {
          this.Documentos[i].Datos[j]._MontoTotal = 0
          this.Documentos[i].Datos[j]._Credito = 0
        } else {
          this.Documentos[i].Datos[j]._Credito = this.Documentos[i].Datos[j].MontoAfectado
          if (this.Documentos[i].Datos[j].Grupo == 'NC') {
            this.Documentos[i].Datos[j]._MontoTotal = this.Documentos[i].Datos[j].Monto * -1
          } else {
            this.Documentos[i].Datos[j]._MontoTotal = this.Documentos[i].Datos[j].Monto
          }
        }

        this.Documentos[i].Datos[j]._MontoNeto = this.Documentos[i].Datos[j]._MontoTotal - this.Documentos[i].Datos[j]._Credito
      }
    }

    this.utilidades.Depuracion(this.Documentos, "console", "")

    setTimeout(() => {
      this.Copia = JSON.stringify(this.Documentos)
    }, 100);
  }

  FiltroPorDocumentoIdentidadNCF() {
    this.Documentos = JSON.parse(this.Copia)
    this.filtrado = true;
    let x = []
    let aux: any;
    for (let familias of this.Documentos) {
      aux = familias;
      aux.Datos = familias.Datos.filter(f => f.NumeroDocumento.toLocaleLowerCase().indexOf(this.filtro.toLocaleLowerCase()) > -1 ||
        f.DocumentoIdentidad.toLocaleLowerCase().indexOf(this.filtro.toLocaleLowerCase()) > -1 ||
        f.Ncf.toLocaleLowerCase().indexOf(this.filtro.toLocaleLowerCase()) > -1)
      x.push(aux)
    }


  }

  TieneDocumentos(fam): boolean {
    for (let j of fam.Datos) {
      if (this.EnArreglo(j.IdEstudiante, this.HijosSeleccionados)) {
        return true;
      }
    }


    return false
  }

  exp = "TablaExportar"
  excel = false
  exportexcel(): void {
    this.exp = ""
    this.excel = true;
    setTimeout(() => {

      const downloadLink = document.createElement("a");
      const dataType = 'application/vnd.ms-excel';
      const table = document.getElementById("datos");
      const tableHtml = table.outerText.replace(/ /g, '%20')
      document.body.appendChild(downloadLink);
      downloadLink.href = 'data:' + dataType + ' ' + tableHtml;
      downloadLink.download = "Comprobantes fiscales " + String(new Date()) + ".xls";
      downloadLink.click();


      this.exp = "TablaExportar"
      this.excel = false
    }, 200);
  }

  TextoMostrable() {
    return '<!DOCTYPE html> <html lang="en"> <head> <meta charset="UTF-8"> <meta http-equiv="X-UA-Compatible" content="IE=edge"> <meta name="viewport" content="width=device-width, initial-scale=1.0"> <title>Comprobantes fiscales</title> <style> *{font-family: "Arial", sans-serif !important;} .h3{margin: 20px 2px 2px 2px; font-size: 16px !important; font-weight: 800 !important;} th{ padding: 5px 10px; font-size: 14px !important;} table { border-collapse: separate; width: 100%; table-layout: fixed; } .table_header th { border-top: 1px solid black; border-bottom: 1px solid black; font-size: 13px;} .table_header th:last-child { border-right: 1px solid black; border-top-right-radius: 5px; border-bottom-right-radius: 5px; } .table_header th:first-child { border-left: 1px solid black; border-top-left-radius: 5px; border-bottom-left-radius: 5px; } .thImp{padding: 7px 10px; font-size: 14px !important; text-align: center; width: 98px;} .thImpC{padding: 7px 10px; font-size: 14px !important; text-align: center; width:225px;} .thImp2{padding: 0 10px; font-size: 1px !important; color:transparent;  text-align: center; width:98px;} .thImpC2{padding: 0 10px; font-size: 1px; color:transparent;  text-align: center; width:225px;} .tdImp{ text-align: left; font-size: 14px; width: 98px !important;} .tdImpC{ text-align: left; font-size: 14px; width: 225px !important;} .tdcantdocs{ padding: 5px 0; border-bottom: 1px solid black; border-top: 1px solid black; text-align: center; font-size: 14px;} td{ text-align: left; font-size: 14px;} .tdEstudianteF{font-size: 14px !important;} .bEstudiante{ font-size: 14px; font-weight: bold !important;} @media print { @page {  size: landscape; } } </style> </head> <body> <div style="text-align: center;"> <h3 class="h3"> INSTITUTO DE DESARROLLO INTEGRAL LEONARDO DA VINCI </h3> <p style="font-size: 14px; margin: 0 0 2px 0;"> "SEA NUESTRO AVAL EL RECTO PENSAR" </p> <p style="font-size: 17px; margin: 0px 1px;"> <b> Listado de Facturas con NCF </b> </p> <p style="font-size: 16px; margin: 2px 1px;"> <b> RNC: </b> {{RNC}} </p> <p style="font-size: 15px; margin: 5px 1px;"> <b> Agrupados por Familias </b> </p> <p style="font-size: 16px; margin: 2px 1px;"> <b>Incluye Docs. Desde:</b> {{FechaDesde}}  <b>Hasta:</b>{{FechaHasta}} </p> </div> <br><br> {{Hola}} </body> </html>'.
      replace("{{Hola}}", document.getElementById("todo").innerHTML).replace("{{RNC}}", this.RNC).replace("{{FechaDesde}}", this.Fecha.Fecha1).replace("{{FechaHasta}}", this.Fecha.Fecha2)
  }

  TextoMostrablePDF() {
    return '<!DOCTYPE html> <html lang="en"> <head> <meta charset="UTF-8"> <meta http-equiv="X-UA-Compatible" content="IE=edge"> <meta name="viewport" content="width=device-width, initial-scale=1.0"> <title>Comprobantes fiscales</title> <style> *{font-family: "Arial", sans-serif !important;} .h3{margin: 20px 2px 2px 2px; font-size: 12px !important; font-weight: 800 !important; text-align: center;} .divEnviar{min-width: 260px;} th{ padding: 5px 10px; font-size: 10px !important;} table { border-collapse: separate; width: 100%; table-layout: fixed; } .table_header th { border-top: 1px solid black; border-bottom: 1px solid black; font-size: 8px;} .table_header th:last-child { border-right: 1px solid black; border-top-right-radius: 5px !important; border-bottom-right-radius: 5px !important; } .table_header th:first-child { border-left: 1px solid black; border-top-left-radius: 5px !important; border-bottom-left-radius: 5px !important; } .thImp{padding: 7px 10px; font-size: 10px !important; text-align: center; width: 55px;} .thImpC{padding: 7px 10px; font-size: 10px !important; text-align: center; width:90px;} .thImp2{padding: 0 10px; font-size: 1px !important; color:transparent;  text-align: center; width:55px;} .thImpC2{padding: 0 10px; font-size: 1px; color:transparent;  text-align: center; width:90px;} .tdImp{ text-align: left; font-size: 10px !important; width: 55px !important;} .tdImpC{ text-align: left; font-size: 10px !important; width: 90px !important;} .tdcantdocs{ padding: 5px 0; border-bottom: 1px solid black; border-top: 1px solid black; text-align: center; font-size: 10px !important;} td{ text-align: left; font-size: 10px !important;} .tdEstudianteF{font-size: 9px !important; text-align: left !important;} .bEstudiante{ font-size: 9px !important; font-weight: bold !important; text-align: left !important; margin-top: 5px;} @media print { @page {  size: landscape; } } </style> </head> <body> <div style="text-align: center;"> <h3 class="h3"> INSTITUTO DE DESARROLLO INTEGRAL LEONARDO DA VINCI </h3> <p style="font-size: 10px; margin: 0 0 2px 0;"> "SEA NUESTRO AVAL EL RECTO PENSAR" </p> <p style="font-size: 12px; margin: 0px 1px;"> <b> Listado de Facturas con NCF </b> </p> <p style="font-size: 11px; margin: 2px 1px;"> <b> RNC: </b> {{RNC}} </p> <p style="font-size: 10px; margin: 5px 1px;"> <b> Agrupados por Familias </b> </p> <p style="font-size: 11px; margin: 2px 1px;"> <b>Incluye Docs. Desde:</b> {{FechaDesde}}  <b>Hasta:</b>{{FechaHasta}} </p> </div> <br><br> {{Hola}} </body> </html>'.
      replace("{{Hola}}", document.getElementById("todo").innerHTML).replace("{{RNC}}", this.RNC).replace("{{FechaDesde}}", this.Fecha.Fecha1).replace("{{FechaHasta}}", this.Fecha.Fecha2)
  }

  exportAsPDF() {
    this.utilidades.Toast("Descargando Excel...", 3000, "download-outline")
    let d = document.getElementById("imprimible")
    d.innerHTML = this.TextoMostrable()

    html2canvas(d).then(canvas => {
      const contentDataURL = canvas.toDataURL('image/png', 1.0)  // 'image/jpeg' for lower quality output.
      // let pdf = new jspdf('l', 'cm', 'a4'); //Generates PDF in landscape mode
      let pdf = new jspdf('p', 'cm', 'a4'); //Generates PDF in portrait mode
      pdf.addImage(contentDataURL, 'PNG', 1, 1, 19, 18);
      pdf.save("Comprobantes fiscales " + String(new Date()) + ".pdf");
      setTimeout(() => {
        d.innerHTML = ""
      }, 300);
    });
  }


  pdfF() {
    this.utilidades.Toast("Descargando PDF...", 3000, "download-outline")
    let d = document.getElementById("imprimible")
    d.innerHTML = this.TextoMostrablePDF()
    this.pdf = "pedefeable"
    document.getElementById("cc").scrollTo({ top: 0, behavior: "smooth" })

    setTimeout(() => {
      let pd = new jspdf('l', 'pt', [1106, 827])
      pd.html(this.pdfTable.nativeElement, {
        "margin": [25, 0, 25, 0], "autoPaging": "text",
        callback: (pdf) => {
          pdf.save("Comprobantes fiscales " + String(new Date()) + ".pdf")
          setTimeout(() => {

          }, 800);
        }
      })
    }, 100);

  }

  EnArreglo(valor, arreglo) {
    for (let i of arreglo) {
      if (Number(valor) == Number(i)) {
        return true;
      }
    }

    return false;
  }

  HayDatos(): boolean {
    if (document.getElementById("datos")) {
      if (document.getElementById("datos").innerText.length > 135) {
        return true;
      }
    }
    return false;
  }
}
